import { render } from "./wasteland.vue?vue&type=template&id=26a92bdc&scoped=true"
import script from "./wasteland.vue?vue&type=script&lang=js"
export * from "./wasteland.vue?vue&type=script&lang=js"

import "./wasteland.vue?vue&type=style&index=0&id=26a92bdc&lang=scss&scoped=true"

import exportComponent from "/Users/wlp9071/workspace/szbProject/lnyx/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26a92bdc"]])

export default __exports__